import { useState, useEffect, useRef } from 'react';
import ax, { INIT_AUTH, LOGIN, LOGOUT_VIEW } from '%/axios';
import conso from '%/conso';
import useSeoLinks from './useSeoLinks';
const init = {
  id: userId || 0,
  fname: '',
  lname: '',
  customer_group: {}
}
const useAuth = ({ poll } = { poll: true }) => {

  const [auth, setAuth] = useState(init);

  const pollRef = useRef();
  const {
    seoLinks
  } = useSeoLinks();

  const login = ({ id, fname, lname,
    address_1,
    address_2,
    zip,
    phone,
    country,
    city,
    state,
    company_name,
    email,
    idme_uuid,
    customer_group_id,
    customer_group = {},
    am_customer_code
  }) => {
    setAuth({
      id,
      fname,
      lname,
      address_1,
      address_2,
      zip,
      phone,
      country,
      city,
      state,
      company_name,
      email,
      idme_uuid,
      customer_group_id,
      customer_group,
      am_customer_code
    })
  }

  const loginAPI = async ({ email, password }) => {
    try {
      const res = await ax(LOGIN, { email, password });
      if (res) {
        login(res);
        return true;
      }
    } catch (er) {
      alert(er.message);

      conso.error(er);
    }
  }


  const initAuth = async (authRoutes = []) => {

    try {
      const res = await ax(INIT_AUTH);
      if (res && auth.fname !== res.fname) {
        login(res);
      } else {
        authPolling(authRoutes);
      }
    } catch (er) {
      authPolling(authRoutes);
      conso.trace(er);
    }
  }

  const logout = async () => {
    try {
      const res = await ax(LOGOUT_VIEW);
      window.location.reload();

    } catch (er) {
      conso.trace(er);
    }
  }

  const authPolling = (authRoutes) => {
    if (!authRoutes.length) return;
    if (authRoutes?.includes(location.pathname.replace('/', ''))) {
      pollRef.current = setTimeout(() => {
        initAuth(authRoutes);
      }, 7000)
    }
  }

  useEffect(() => {
    if (seoLinks['auth.login'] && poll) {
      initAuth([seoLinks['auth.login'], seoLinks['auth.register']]);
    }
  }, [seoLinks])

  return {
    auth,
    login,
    initAuth,
    loginAPI,
    logout
  }
}
export default useAuth;